<template>
<div class="chapter">
<div class="inner_page">
<h1 class="c" id="pgepubid00000">CAPTAINS COURAGEOUS</h1>
<h3 class="c2 sigil_not_in_toc" id="pgepubid00002">by</h3>
<h2 class="c1 sigil_not_in_toc" id="pgepubid00003">Rudyard Kipling</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?7f8e1c3c